import React, { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Avatar, Box, CircularProgress, Grid, Link, Menu, Typography, useTheme } from "@mui/material";
import CommonCard from "../../common/components/CommonCard";
import CommonDialog from "../../common/components/CommonDialog";
import CommonButton from "../../common/components/CommonButton";
import { KeyboardArrowDown, MovingOutlined, Person, ScheduleOutlined } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { LoginType } from "../../common/const";
import { getTaskDashboard } from "../../api/authApi";
import { showNotification } from "../../common/components/Notification/ToastifyNotification";
import { setLoading } from "../../features/authSlice";

const Header = ({
    colleges
}) => {
    const dispatch = useDispatch();
    const theme = useTheme();
    const navigate = useNavigate();
    const { user } = useSelector((state) => state.auth);
    const [rewardOpen, setRewardOpen] = useState(false);
    const [anchor, setAnchor] = useState(null);
    const [fromHeader, setFromHeader] = useState(false);
    const [previewUrl, setPreviewUrl] = useState('');
    const [tasks, setTasks] = useState(null);

    const getTaskData = async () => {
        try {
            dispatch(setLoading({ loading: true }));
            const response = await getTaskDashboard();
            setTasks(response?.data);
            dispatch(setLoading({ loading: false }));
        } catch (err) {
            const errorMessage = err.response?.data?.errors?.[0]?.message ||
                err.response?.data?.message ||
                err?.response?.data?.error;
            showNotification(errorMessage, 'error');
            dispatch(setLoading({ loading: false }));
        }
    };

    useEffect(() => {
        if (user?.avatar) {
            const getImage = async () => {
                if (user.login_type === LoginType.EMAIL) {
                    const responseData = await fetch(`${process.env.REACT_APP_BASE_URL}/file?bname=${user.avatar}&download=false`, {
                        headers: {
                            'Authorization': `Bearer ${localStorage.getItem('token')}`
                        }
                    });
                    const blob = await responseData.blob();
                    const imageUrl = URL.createObjectURL(blob);
                    setPreviewUrl(imageUrl);
                } else {
                    setPreviewUrl(user?.avatar);
                }
            }
            getImage();
            getTaskData();
        }
    }, [user]);

    return (
        <Fragment>
            <CommonDialog
                open={rewardOpen}
                size="xs"
                padding={0}
                background="#F9F9F9"
                title={
                    <img
                        src="/Images/rewardbackground.png"
                        alt="reward"
                        width="100%"
                        onClick={() => setRewardOpen(false)}
                    />
                }
                content={
                    <Fragment>
                        <Typography textAlign="center" fontSize={18} color={theme.palette.secondary.main} fontWeight={600}>In Which year was LMU Munich established?</Typography>
                        <Box
                            display="flex"
                            gap={2}
                            mb={2}
                            mt={2}
                        >
                            <CommonButton
                                label="a. 1965"
                                marginBottom="0px"
                                background="#FFFFFF"
                                borderRadius={10}
                            />
                            <CommonButton
                                label="b. 1972"
                                marginBottom="0px"
                                background="#FFFFFF"
                                borderRadius={10}
                            />
                        </Box>
                        <Box
                            display="flex"
                            gap={2}
                            mb={2}
                        >
                            <CommonButton
                                label="c. 1985"
                                marginBottom="0px"
                                background="#FFFFFF"
                                borderRadius={10}
                            />
                            <CommonButton
                                label="d. 1990"
                                marginBottom="0px"
                                background="#FFFFFF"
                                borderRadius={10}
                            />
                        </Box>
                        <center>
                            <CommonButton
                                color={theme.palette.primary.main}
                                background={theme.palette.secondary.main}
                                label="Submit"
                                size="small"
                                width="100px"
                                handleClick={() => setRewardOpen(false)}
                                marginBottom="0px"
                            />
                        </center>
                    </Fragment>
                }
            />
            <Grid item xs={12} md={4}>
                <Box
                    sx={{
                        position: 'relative', // Parent container
                        width: '100%',
                        height: '156px',
                        borderRadius: '16px'
                    }}
                >
                    {/* Background Image */}
                    <Box
                        component="img"
                        src="./Images/dashboardbackground.png"
                        alt='logo'
                        sx={{
                            width: '100%',
                            height: '100%',
                            borderRadius: '16px',
                            objectFit: 'cover' // Ensures image covers the area
                        }}
                    />

                    {/* Content Overlay */}
                    <Box
                        sx={{
                            position: 'absolute',
                            top: 25,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            borderRadius: '16px',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between'
                        }}
                    >
                        {/* Top Section with Profile and Reward */}
                        <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between"
                            sx={{
                                padding: '8px 16px'
                            }}
                        >
                            <Box
                                display="flex"
                                alignItems="center"
                                gap={2}
                            >
                                {previewUrl ? (
                                    <Avatar
                                        src={previewUrl}
                                        sx={{
                                            width: '80px',
                                            height: '80px',
                                            backgroundColor: theme.palette.grey[200],
                                            cursor: 'pointer',
                                        }}
                                    >
                                    </Avatar>
                                ) : (
                                    <Avatar
                                        sx={{
                                            width: '80px',
                                            height: '80px',
                                            fontSize: '1rem',
                                            fontWeight: 600,
                                            background: theme.palette.secondary.main,
                                            color: theme.palette.primary.main,
                                            border: '2px solid white'
                                        }}
                                    >
                                        {`${user?.first_name?.charAt(0)?.toUpperCase()} ${user?.last_name?.charAt(0)?.toUpperCase()}`}
                                    </Avatar>
                                )}
                                <Box>
                                    <Typography fontSize={20} color="white" fontWeight={600}>
                                        Hello, <span style={{ color: theme.palette.primary.main }}>{user?.first_name} !</span>
                                    </Typography>
                                    <Typography fontSize={18} color="rgba(255, 255, 255, 0.9)">
                                        Continue my college application journey
                                    </Typography>
                                </Box>
                            </Box>
                            <img
                                src="/Images/reward.gif"
                                alt="reward"
                                height="70px"
                                style={{
                                    cursor: 'pointer',
                                    filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.3))' // Adds shadow for better visibility
                                }}
                                // onClick={() => setRewardOpen(true)}
                            />
                        </Box>
                    </Box>
                </Box>
            </Grid>
            <Grid item xs={12} md={8}>
                <Grid container spacing={2}>
                    <Grid item md={3} sm={6} xs={12}>
                        <CommonCard
                            borderRadius={2}
                            content={
                                <Fragment>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'space-between'
                                        }}
                                    >
                                        <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                                            {/* Gray background circle (always shows full circle) */}
                                            <CircularProgress
                                                variant="determinate"
                                                value={100}
                                                size={50}
                                                thickness={6}
                                                sx={{
                                                    color: '#e0e0e0', // Light gray for remaining portion
                                                    position: 'absolute',
                                                    '& .MuiCircularProgress-circle': {
                                                        strokeLinecap: 'round',
                                                    },
                                                }}
                                            />

                                            {/* Green progress circle on top */}
                                            <CircularProgress
                                                variant="determinate"
                                                value={user?.students_completed_profile_percentage ? Math.round(user?.students_completed_profile_percentage) : 0}
                                                size={50}
                                                thickness={6}
                                                sx={{
                                                    color: Math.round(user?.students_completed_profile_percentage) === 100
                                                        ? theme.palette.secondary.default// Full green
                                                        : theme.palette.secondary.default, // Your progress color
                                                    '& .MuiCircularProgress-circle': {
                                                        strokeLinecap: 'round',
                                                    },
                                                }}
                                            />

                                            {/* Optional: Center text */}
                                            <Box
                                                sx={{
                                                    top: 0,
                                                    left: 0,
                                                    bottom: 0,
                                                    right: 0,
                                                    position: 'absolute',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                }}
                                            >
                                                <Typography
                                                    fontSize={12}
                                                    component="div"
                                                    fontWeight={700}
                                                    color="text.primary"
                                                >
                                                    {`${user?.students_completed_profile_percentage ? Math.round(user?.students_completed_profile_percentage) : 0}%`}
                                                </Typography>
                                            </Box>
                                        </Box>
                                        <Box
                                            sx={{
                                                background: '#DBFEE0',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                borderRadius: '50%',
                                                width: 45,
                                                height: 45,
                                            }}
                                        >
                                            <Person sx={{ color: '#08ba08' }} />
                                        </Box>
                                    </Box>
                                    <Typography fontSize={14} mt={1.5}>My Profile</Typography>
                                    <Typography fontSize={14} mb={3.3}>Completion</Typography>
                                </Fragment>
                            }
                            paddingBottom="0px"
                            padding="13px"
                            marginTop="0px"
                        />
                    </Grid>
                    <Grid item md={3} sm={6} xs={12}>
                        <CommonCard
                            borderRadius={2}
                            content={
                                <Fragment>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'space-between'
                                        }}
                                    >
                                        <Box>
                                            <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                                                {/* Gray background circle (always shows full circle) */}
                                                <CircularProgress
                                                    variant="determinate"
                                                    value={100}
                                                    size={50}
                                                    thickness={6}
                                                    sx={{
                                                        color: '#e0e0e0', // Light gray for remaining portion
                                                        position: 'absolute',
                                                        '& .MuiCircularProgress-circle': {
                                                            strokeLinecap: 'round',
                                                        },
                                                    }}
                                                />

                                                {/* Green progress circle on top */}
                                                <CircularProgress
                                                    variant="determinate"
                                                    value={user?.indexScore[user?.student_current_grade] || user?.indexScore?.GRDAE_9 || user?.indexScore?.GRADE_10 || user?.indexScore?.GRADE_11 || user?.indexScore?.GRADE_12}
                                                    size={50}
                                                    thickness={6}
                                                    sx={{
                                                        color: (user?.indexScore[user?.student_current_grade] || user?.indexScore?.GRDAE_9 || user?.indexScore?.GRADE_10 || user?.indexScore?.GRADE_11 || user?.indexScore?.GRADE_12) > 90
                                                            ? theme.palette.secondary.default // Full green
                                                            : (user?.indexScore[user?.student_current_grade] || user?.indexScore?.GRDAE_9 || user?.indexScore?.GRADE_10 || user?.indexScore?.GRADE_11 || user?.indexScore?.GRADE_12) < 90 ? 
                                                            theme.palette.primary.main
                                                            : (user?.indexScore[user?.student_current_grade] || user?.indexScore?.GRDAE_9 || user?.indexScore?.GRADE_10 || user?.indexScore?.GRADE_11 || user?.indexScore?.GRADE_12) < 60 ?
                                                            'red' : 
                                                            theme.palette.secondary.default , // Your progress color
                                                        '& .MuiCircularProgress-circle': {
                                                            strokeLinecap: 'round',
                                                        },
                                                    }}
                                                />

                                                {/* Optional: Center text */}
                                                <Box
                                                    sx={{
                                                        top: 0,
                                                        left: 0,
                                                        bottom: 0,
                                                        right: 0,
                                                        position: 'absolute',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    <Typography
                                                        fontSize={12}
                                                        component="div"
                                                        fontWeight={700}
                                                        color="text.primary"
                                                    >
                                                        {user?.student_current_grade ? user?.indexScore[user?.student_current_grade] : (user?.indexScore?.GRDAE_9 || user?.indexScore?.GRADE_10 || user?.indexScore?.GRADE_11 || user?.indexScore?.GRADE_12)}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                            <Typography fontSize={14}>My Dcp</Typography>
                                        </Box>
                                        <Box
                                            sx={{
                                                background: '#DBEAFE',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                borderRadius: '50%',
                                                width: 45,
                                                height: 45,
                                            }}
                                            onClick={(e) => {
                                                setAnchor(e.currentTarget);
                                                setFromHeader(true);
                                            }}
                                        >
                                            <MovingOutlined sx={{ color: '#155DFC' }} />
                                        </Box>
                                    </Box>
                                    <Box display="flex" justifyContent="space-between">
                                        <Box mb={1.8}>
                                            <Typography fontSize={14}>Index Score</Typography>
                                            <Typography fontSize={12} color={theme.palette.background.dark}>(Out of 100)</Typography>
                                        </Box>
                                        <KeyboardArrowDown sx={{ color: theme.palette.background.dark, cursor: 'pointer' }} onClick={(e) => {
                                            setAnchor(e.currentTarget);
                                            setFromHeader(false);
                                        }} />
                                    </Box>
                                    <Menu
                                        anchorEl={anchor}
                                        open={Boolean(anchor)}
                                        onClose={() => {
                                            setAnchor(null);
                                            setFromHeader(false);
                                        }}
                                        PaperProps={{
                                            sx: {
                                                mt: fromHeader ? 1 : 5,
                                                width: '200px',
                                                borderRadius: '8px',
                                                boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                                            }
                                        }}
                                        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                                        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                                    >
                                        <Box p={1}>
                                            <Box display="flex" justifyContent="space-between">
                                                <Typography fontSize={14}>Grade 9</Typography>
                                                <Typography fontSize={14}>DCP SCORE
                                                    <span
                                                        style={{
                                                            fontWeight: 600,
                                                            marginLeft: 5,
                                                            color: user?.indexScore?.GRADE_9 < 60 ? 'red' : user?.indexScore?.GRADE_9 < 90 ? theme.palette.primary.main : 'green'
                                                        }}>
                                                        {user?.indexScore?.GRADE_9}
                                                    </span>
                                                </Typography>
                                            </Box>
                                            <Box display="flex" justifyContent="space-between">
                                                <Typography fontSize={14}>Grade 10</Typography>
                                                <Typography fontSize={14}>DCP SCORE
                                                    <span
                                                        style={{
                                                            fontWeight: 600,
                                                            marginLeft: 5,
                                                            color: user?.indexScore?.GRADE_10 < 60 ? 'red' : user?.indexScore?.GRADE_10 < 90 ? theme.palette.primary.main : 'green'
                                                        }}>
                                                        {user?.indexScore?.GRADE_10}
                                                    </span>
                                                </Typography>
                                            </Box>
                                            <Box display="flex" justifyContent="space-between">
                                                <Typography fontSize={14}>Grade 11</Typography>
                                                <Typography fontSize={14}>DCP SCORE
                                                    <span
                                                        style={{
                                                            fontWeight: 600,
                                                            marginLeft: 5,
                                                            color: user?.indexScore?.GRADE_11 < 60 ? 'red' : user?.indexScore?.GRADE_11 < 90 ? theme.palette.primary.main : 'green'
                                                        }}>
                                                        {user?.indexScore?.GRADE_11}
                                                    </span>
                                                </Typography>
                                            </Box>
                                            <Box display="flex" justifyContent="space-between">
                                                <Typography fontSize={14}>Grade 12</Typography>
                                                <Typography fontSize={14}>DCP SCORE
                                                    <span
                                                        style={{
                                                            fontWeight: 600,
                                                            marginLeft: 5,
                                                            color: user?.indexScore?.GRADE_12 < 60 ? 'red' : user?.indexScore?.GRADE_12 < 90 ? theme.palette.primary.main : 'green'
                                                        }}>
                                                        {user?.indexScore?.GRADE_12}
                                                    </span>
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Menu>
                                </Fragment>
                            }
                            paddingBottom="0px"
                            padding="13px"
                            marginTop="0px"
                        />
                    </Grid>
                    <Grid item md={3} sm={6} xs={12}>
                        <CommonCard
                            borderRadius={2}
                            content={
                                <Fragment>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'space-between'
                                        }}
                                    >
                                        <Box>
                                            <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                                                {/* Gray background circle (always shows full circle) */}
                                                <CircularProgress
                                                    variant="determinate"
                                                    value={100}
                                                    size={50}
                                                    thickness={6}
                                                    sx={{
                                                        color: '#e0e0e0', // Light gray for remaining portion
                                                        position: 'absolute',
                                                        '& .MuiCircularProgress-circle': {
                                                            strokeLinecap: 'round',
                                                        },
                                                    }}
                                                />

                                                {/* Green progress circle on top */}
                                                <CircularProgress
                                                    variant="determinate"
                                                    value={(colleges.length / 20) * 100}
                                                    size={50}
                                                    thickness={6}
                                                    sx={{
                                                        color: colleges.length >= 20
                                                            ? theme.palette.secondary.default // Full green
                                                            : theme.palette.secondary.default, // Your progress color
                                                        '& .MuiCircularProgress-circle': {
                                                            strokeLinecap: 'round',
                                                        },
                                                    }}
                                                />

                                                {/* Optional: Center text */}
                                                <Box
                                                    sx={{
                                                        top: 0,
                                                        left: 0,
                                                        bottom: 0,
                                                        right: 0,
                                                        position: 'absolute',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    <Typography
                                                        fontSize={12}
                                                        component="div"
                                                        fontWeight={700}
                                                        color="text.primary"
                                                    >
                                                        {`${colleges.length}`}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                            <Typography fontSize={14}>My Total College List</Typography>
                                        </Box>
                                        <img src="./Images/dashboard_2.png" alt="dashboard_2" height="45px" width="45px" />
                                    </Box>
                                    <Typography fontSize={12} color={theme.palette.background.dark}>x selected out of 20</Typography>
                                    <Box display="flex" gap={1}>
                                        <Box sx={{ background: '#FFE2E2', pt: 0.2, pb: 0.2, textAlign: 'center', borderRadius: 0.5, minWidth: 60, width: 60, mt: 1.6 }}>
                                            <Typography sx={{ fontSize: 12, color: 'red' }}>{colleges.filter((a) => a.list_type === 'DREAM').length} Dream</Typography>
                                        </Box>
                                        <Box sx={{ background: '#FEF9C2', pt: 0.2, pb: 0.2, textAlign: 'center', borderRadius: 0.5, minWidth: 60, width: 60, mt: 1.6 }}>
                                            <Typography sx={{ fontSize: 12, color: '#894B00' }}>{colleges.filter((a) => a.list_type === 'TARGET').length} Target</Typography>
                                        </Box>
                                        <Box sx={{ background: theme.palette.cardbackground.light, pt: 0.2, pb: 0.2, textAlign: 'center', borderRadius: 0.5, minWidth: 60, width: 60, mt: 1.6 }}>
                                            <Typography sx={{ fontSize: 12, color: theme.palette.cardbackground.middle }}>{colleges.filter((a) => a.list_type === 'SAFE').length} Safe</Typography>
                                        </Box>
                                    </Box>
                                </Fragment>
                            }
                            paddingBottom="0px"
                            padding="13px"
                            marginTop="0px"
                        />
                    </Grid>
                    <Grid item md={3} sm={6} xs={12}>
                        <CommonCard
                            borderRadius={2}
                            content={
                                <Fragment>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'space-between'
                                        }}
                                    >
                                        <Box>
                                            <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                                                {/* Gray background circle (always shows full circle) */}
                                                <CircularProgress
                                                    variant="determinate"
                                                    value={100}
                                                    size={50}
                                                    thickness={6}
                                                    sx={{
                                                        color: '#e0e0e0', // Light gray for remaining portion
                                                        position: 'absolute',
                                                        '& .MuiCircularProgress-circle': {
                                                            strokeLinecap: 'round',
                                                        },
                                                    }}
                                                />

                                                {/* Green progress circle on top */}
                                                <CircularProgress
                                                    variant="determinate"
                                                    value={(tasks?.pending_task / tasks?.total_task) * 100}
                                                    size={50}
                                                    thickness={6}
                                                    sx={{
                                                        color: ((tasks?.pending_task / tasks?.total_task) * 100) >= 70
                                                            ? theme.palette.secondary.default // Full green
                                                            : ((tasks?.pending_task / tasks?.total_task) * 100) >= 30  ? 
                                                            theme.palette.primary.main
                                                            : ((tasks?.pending_task / tasks?.total_task) * 100) > 0 ? 'red' : '#e0e0e0', // Your progress color
                                                        '& .MuiCircularProgress-circle': {
                                                            strokeLinecap: 'round',
                                                        },
                                                    }}
                                                />

                                                {/* Optional: Center text */}
                                                <Box
                                                    sx={{
                                                        top: 0,
                                                        left: 0,
                                                        bottom: 0,
                                                        right: 0,
                                                        position: 'absolute',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    <Typography
                                                        fontSize={12}
                                                        component="div"
                                                        fontWeight={700}
                                                        color="text.primary"
                                                    >
                                                        {tasks?.pending_task || 0}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                            <Typography fontSize={14}>My Pending</Typography>
                                        </Box>
                                        <Box
                                            sx={{
                                                background: '#FFEDD4',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                borderRadius: '50%',
                                                width: 45,
                                                height: 45,
                                            }}
                                        >
                                            <ScheduleOutlined sx={{ color: '#F54900' }} />
                                        </Box>
                                    </Box>
                                    <Typography fontSize={14} mb={1}>Tasks</Typography>
                                    <Link
                                        sx={{
                                            color: 'red',
                                            textDecoration: 'underline',
                                            textDecorationColor: 'red', // Direct color
                                            '&:hover': {
                                                textDecorationColor: 'red', // Change on hover
                                                textUnderlineOffset: '6px', // Can change on hover
                                            },
                                            textUnderlineOffset: '4px', // Space between text and underline
                                            fontSize: 15
                                        }}
                                        onClick={() => navigate('/my-dcp-counsellor')}
                                    >
                                        View more
                                    </Link>
                                </Fragment>
                            }
                            paddingBottom="0px"
                            padding="13px"
                            marginTop="0px"
                        />
                    </Grid>
                </Grid>
            </Grid>
        </Fragment >
    )
}

export default Header;